var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteProfitLost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(0 -0.009)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 20,
    height: 20,
    transform: "translate(0 0.009)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(0 -0.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M1720.39,2047.374a5.435,5.435,0,1,0,5.545,5.433A5.49,5.49,0,0,0,1720.39,2047.374Zm1.851,7.692a2.276,2.276,0,0,1-1.233.606v.913h-1.154v-.881a4.193,4.193,0,0,1-.985-.19,2.913,2.913,0,0,1-.787-.384l.47-1.051a3.164,3.164,0,0,0,1.732.509q.907,0,.907-.565a.38.38,0,0,0-.248-.36,4.63,4.63,0,0,0-.816-.255,7.561,7.561,0,0,1-1.006-.315,1.8,1.8,0,0,1-.688-.5,1.351,1.351,0,0,1-.293-.913,1.526,1.526,0,0,1,.462-1.107,2.308,2.308,0,0,1,1.22-.622v-.921h1.154v.889a4.3,4.3,0,0,1,.891.214,2.263,2.263,0,0,1,.667.359l-.47,1.05a3.576,3.576,0,0,0-.808-.384,2.537,2.537,0,0,0-.783-.133,1.109,1.109,0,0,0-.606.145.462.462,0,0,0-.227.412.4.4,0,0,0,.144.311,1,1,0,0,0,.359.194q.214.07.61.166a7.414,7.414,0,0,1,.99.291,1.63,1.63,0,0,1,.676.493,1.391,1.391,0,0,1,.28.913A1.523,1.523,0,0,1,1722.241,2055.066Z",
    transform: "translate(-1710.086 -2043.111)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(1.311 1.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M1699.864,2029.849l-.038-.031-.039-.028-.039-.023-.046-.024-.017-.009-.023-.008-.05-.017-.042-.011-.05-.009-.044,0-.05,0-.045,0-.048.005-.046.009-.045.011-.048.016-.024.009-.017.009c-.016.007-.03.015-.045.024l-.04.024-.039.028-.038.031-.015.013-2.445,2.33.9.948,1.338-1.275v4.408h1.31v-4.408l1.338,1.275.9-.948-2.445-2.33Z",
    transform: "translate(-1696.531 -2029.682)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M1762.867,2093.6l.013-.01,2.445-2.33-.9-.948-1.338,1.275v-4.408h-1.31v4.408l-1.338-1.275-.9.948,2.445,2.33.012.01a.608.608,0,0,0,.074.058l.017.013a.623.623,0,0,0,.09.048l.008,0a.755.755,0,0,0,.086.027c.012,0,.024.008.037.01a.664.664,0,0,0,.121.012h.011a.666.666,0,0,0,.121-.012c.012,0,.025-.007.037-.01a.76.76,0,0,0,.086-.027l.008,0a.623.623,0,0,0,.09-.048l.017-.013A.59.59,0,0,0,1762.867,2093.6Z",
    transform: "translate(-1747.742 -2077.231)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteProfitLost);
export default __webpack_public_path__ + "static/media/white_profit_lost.a14f1f74761d346b4f00f6250d3ac2be.svg";
export { ForwardRef as ReactComponent };